import React, { useEffect, useState } from 'react';
import { FaSearch, FaWifi, FaBuilding, FaUsers } from 'react-icons/fa';
import { Link, useParams } from 'react-router-dom';
import GlobalSearch from '../components/GlobalSearch';
import GroupForm from '../components/GroupForm';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';
import { useUserContext } from '../context/UserContext';
import Home from './GroupPages/Home';
import Member from './GroupPages/Member';
import Media from './GroupPages/Media';
import Invites from '../components/Group/Invites';
import GroupChat from './GroupPages/GroupChat';

function Detailgroup() {
    const { id } = useParams();
    const auth = JSON.parse(secureLocalStorage.getItem('auth_data'));
    const [group, setGroup] = useState(null);
    const { groupTab, setGroupTab } = useUserContext();
    const [showFullDescription, setShowFullDescription] = useState(false);
    const [coverKey, setCoverKey] = useState(Date.now());
    const [memberCount, setMemberCount] = useState(0);
    const [isMember, setIsMember] = useState(false);
    const [newestFollowers, setNewestFollowers] = useState([]);

    const fetchMemberCount = async (groupId) => {
        try {
            const res = await axios.get(`https://buzzinguniverse.com/backend/api/groups/all-members?group_id=${groupId}&page=1`);
            const membersData = res.data?.data;
            setMemberCount(membersData?.total || 0);
            setNewestFollowers(membersData?.data?.slice(0, 8) || []);

            // Check if current user is in the members list
            if (auth?.id && membersData?.data) {
                const found = membersData.data.some(mem => mem.user?.id === auth.id);
                if (found) setIsMember(true);
            }
        } catch (err) {
            console.error("Failed to fetch member count:", err);
        }
    };

    const checkMembership = async (groupId) => {
        if (!auth?.id) return;
        try {
            let page = 1;
            let found = false;
            let lastPage = 1;
            while (page <= lastPage && !found) {
                const res = await axios.get(`https://buzzinguniverse.com/backend/api/groups/all-members?group_id=${groupId}&page=${page}`);
                const data = res.data?.data;
                lastPage = data?.last_page || 1;
                if (data?.data?.some(mem => mem.user?.id === auth.id)) {
                    found = true;
                }
                page++;
            }
            setIsMember(found);
        } catch (err) {
            console.error("Failed to check membership:", err);
        }
    };

    const fetchGroup = async () => {
        try {
            const res = await axios.get(`https://buzzinguniverse.com/backend/api/groups/get?group_id=${id}${auth?.id ? `&user_id=${auth?.id}` : ''}`);
            const groupData = res.data?.data || null;
            setGroup(groupData);
            setCoverKey(Date.now());
            if(!groupData){
                window.location.replace('/groups');
                return;
            }
            // If backend returns membership, trust it
            if (groupData.membership) {
                setIsMember(true);
            }
        } catch (err) {
            console.error("Failed to fetch group:", err);
        }
    };

    const JoinGroup = async (e) => {
        e.preventDefault();
        e.target.classList.add('loadin');
        try {
            await axios.get(`https://buzzinguniverse.com/backend/api/groups/join?group_id=${id}&user_id=${auth.id}`);
            setIsMember(true);
            fetchGroup();
            fetchMemberCount(id);
            e.target.classList.remove('loadin');
        } catch (err) {
            console.error("Failed to join group:", err);
        }
    };

    const LeaveGroup = async (e) => {
        e.preventDefault();
        e.target.classList.add('loadin');
        try {
            await axios.get(`https://buzzinguniverse.com/backend/api/groups/leave?group_id=${id}&user_id=${auth.id}`);
            setIsMember(false);
            fetchGroup();
            fetchMemberCount(id);
            e.target.classList.remove('loadin');
        } catch (err) {
            console.error("Failed to leave group:", err);
        }
    };

    useEffect(() => {
        fetchGroup();
        fetchMemberCount(id);
        checkMembership(id);
    }, [id]);

    if (!group) return <div className="loading" />;

    const isCompany = group.type === 'company';
    const entityLabel = isCompany ? 'Company' : 'Group';
    const canPost = isCompany
        ? (group.membership?.role === 'admin' || group.membership?.role === 'moderator')
        : !!group.membership;

    const toggleDescription = () => {
        setShowFullDescription(prev => !prev);
    };

    const truncatedDescription = group?.description?.length > 90
        ? group.description.slice(0, 90) + '...'
        : group.description;


    return (
        <div>
            <GlobalSearch />

            <section className="public-group">
                <div className="container-fluid">
                    <div
                        className="admin-top"
                        style={{
                            backgroundImage: group.cover_photo
                                ? `url("https://buzzinguniverse.com/backend/${encodeURI(group.cover_photo)}?v=${coverKey}")`
                                : `radial-gradient(circle, rgb(153 153 153) 0%, rgba(0, 0, 0, 0.15) 58%, rgba(0, 0, 0, 0.3) 100%)`,
                        }}
                    >
                        <div className="group-admin">
                            <span>{entityLabel} Administrators</span>
                            <div>
                                {
                                    group.admins && group.admins.map((admin, key) => (
                                        key < 10 && <Link key={admin.user.id} to={`/member/${admin.user.id}/profile`}><img
                                            src={admin.user.photo
                                                ? `https://buzzinguniverse.com/backend/${admin.user.photo}`
                                                : "/images/default.png"} alt={admin.user.first_name} /></Link>
                                    ))
                                }
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '10px', alignItems: 'center' }}>
                            {auth && group.user_id != auth?.id && (
                                isMember
                                    ? <button className='joinGroupBtn' onClick={LeaveGroup}>Leave {entityLabel}</button>
                                    : <button className='joinGroupBtn' onClick={JoinGroup}>Join {entityLabel}</button>
                            )}
                            {isCompany && auth && group.membership?.role !== 'admin' && (
                                <button
                                    className='joinGroupBtn'
                                    style={{ background: 'rgba(255,255,255,0.15)', backdropFilter: 'blur(4px)', display: 'flex', alignItems: 'center', gap: '6px' }}
                                    onClick={() => {
                                        setGroupTab('chat');
                                        setTimeout(() => {
                                            document.querySelector('.group-detail-right')?.scrollIntoView({ behavior: 'smooth' });
                                        }, 100);
                                    }}
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                        <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
                                    </svg>
                                    Message
                                </button>
                            )}
                        </div>

                    </div>
                </div>

                <div className="group-detail chg">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-md-3">
                                <div className="grp-img" data-online={true}>
                                    {group.profile_picture ? (
                                        <img
                                            src={`https://buzzinguniverse.com/backend/${group.profile_picture}`}
                                            alt={group.name}
                                        />
                                    ) : isCompany ? (
                                        <div className="company-icon-placeholder detail">
                                            <FaBuilding />
                                        </div>
                                    ) : (
                                        <img
                                            src="/images/mystery-group.png"
                                            alt={group.name}
                                        />
                                    )}
                                    <h3>{group.name}</h3>
                                </div>
                            </div>
                            <div className="col-md-9">
                                <h4> {group.privacy ? group.privacy.charAt(0).toUpperCase() + group.privacy.slice(1) : ''} {entityLabel} <span><FaUsers style={{ marginRight: 4 }} />{memberCount} {isCompany ? (memberCount === 1 ? 'Follower' : 'Followers') : (memberCount === 1 ? 'Member' : 'Members')}</span> </h4>
                                <ul className="group-nav">
                                    <li onClick={() => setGroupTab('home')}>Home</li>
                                    <li onClick={() => setGroupTab('members')}>{isCompany ? 'Followers' : 'Members'}</li>
                                    <li onClick={() => setGroupTab('media')}>Media</li>
                                    {!isCompany && isMember && auth && (
                                        <li onClick={() => setGroupTab('chat')}>Chat</li>
                                    )}
                                    {isCompany && auth && group.membership?.role !== 'admin' && (
                                        <li onClick={() => setGroupTab('chat')}>Message</li>
                                    )}
                                    {group.membership?.role === 'admin' && <>
                                        {isCompany && <li onClick={() => setGroupTab('inbox')}>Inbox</li>}
                                        <li onClick={() => setGroupTab('invites')}>Invite</li>
                                        <li onClick={() => setGroupTab('manage')}>Manage</li>
                                    </>}
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="group-detail-sec">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-3">
                                <div className="group-detail-left">
                                    <div className="group-detail-about-group mb-4">
                                        <h2>About {entityLabel}</h2>
                                        <p>
                                            {showFullDescription ? group.description : truncatedDescription}
                                            <br />
                                            {group.description?.length > 200 && (
                                                <button
                                                    className="btn p-0 ms-2"
                                                    onClick={toggleDescription}
                                                    style={{ fontSize: '0.9rem', fontWeight: '500' }}
                                                >
                                                    {showFullDescription ? 'Read Less' : 'Read More'}
                                                </button>
                                            )}
                                        </p>
                                    </div>
                                    {isCompany && group.url && (
                                        <div className="group-detail-about-group mb-4">
                                            <h2>Website</h2>
                                            <a href={/^https?:\/\//i.test(group.url) ? group.url : `https://${group.url}`} target="_blank" rel="noopener noreferrer" style={{ wordBreak: 'break-all', fontSize: '0.9rem' }}>
                                                {group.url}
                                            </a>
                                        </div>
                                    )}
                                    <div className="group-detail-about-group">
                                        <h2>Newest {isCompany ? 'Followers' : 'Members'}</h2>
                                        {newestFollowers.length > 0 ? (
                                            <div className="adminslist-adf">
                                                {newestFollowers.map((member) => (
                                                    <Link key={member.user?.id} to={`/member/${member.user?.id}/profile`}>
                                                        <img
                                                            src={member.user?.photo
                                                                ? `https://buzzinguniverse.com/backend/${member.user.photo}`
                                                                : "/images/default.png"}
                                                            alt={member.user?.first_name}
                                                            title={`${member.user?.first_name} ${member.user?.last_name}`}
                                                        />
                                                    </Link>
                                                ))}
                                            </div>
                                        ) : (
                                            <p style={{ fontSize: '0.85rem', color: '#888' }}>No {isCompany ? 'followers' : 'members'} yet</p>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-9 col-md-9">
                                <div className="group-detail-right mt-5">
                                    {groupTab === 'home' && <Home group={group} groupId={group.id} usrAuth={canPost} />}
                                    {groupTab === 'members' && <Member group={group} />}
                                    {groupTab === 'media' && <Media group={group} UserAuth={group.membership?.role === 'admin'} groupId={group.id} />}
                                    {groupTab === 'chat' && auth && <GroupChat group={group} auth={auth} />}
                                    {groupTab === 'inbox' && auth && group.membership?.role === 'admin' && <GroupChat group={group} auth={auth} />}
                                    {groupTab === 'invites' && <Invites group={group} />}
                                    {groupTab === 'manage' && <GroupForm group={group} fetchGroup={fetchGroup} />}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}

export default Detailgroup;
